import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import {
  addNewClientAPI,
  getGeneratedUsernameAPI,
  getUserDataAPI,
  getChildUserInfoAPI,
  getUsersWithUserTypeAPI,
} from "../service/UserService";
import { Encrypt } from "../utils/constants";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { APP_NAME, PERMISSION_MAP, PLATFORM } from "../utils/constants";

export default function CreateClient() {

  // const currentLvl = PERMISSION_MAP[currentUserType];


  const [clientData, setClientData] = useState({});
  const location = useLocation();
  const [globalSetting, setGlobalSetting] = useState({});
  const userType = useParams()?.usertype;

  const [payload, setPayload] = useState({
    matchCommission: userType?.toLowerCase() === "client" ? 0 : 0,
    sessionCommission: userType?.toLowerCase() === "client" ? 0 : 0,
    casinoCommission: userType?.toLowerCase() === "client" ? 0 : 0,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [done, setDone] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const [userTypeList, setUserTypeList] = useState();
  const [selectedParent, setSelectedParent] = useState(
    userType?.toUpperCase() == "ADMIN" ||
      userType?.toUpperCase() == "CONTROLLER"
      ? {
        value: userData?.uid,
        label: userData?.username,
      }
      : location?.state?.selectedUsers
  );

  // console.log(location?.state?.selectedUsers)
  const [isCommission, setIsCommission] = useState("yes");
  const [isCasinoCommission, setIsCasinoCommission] = useState("yes");
  const [isMatkaCommission, setIsMatkaCommission] = useState("no");
  const getDefaultGeneratedUsername = async () => {
    const { response } = await getGeneratedUsernameAPI(userType);
    setPayload({ ...payload, username: response.username });
  };
  const getUsersWithUserType = async () => {
    let userTypeGet = userType;
    if (userType?.toUpperCase() === "SUB_ADMIN") {
      userTypeGet = "ADMIN";
    } else if (userType?.toUpperCase() === "MASTER") {
      userTypeGet = "SUB_ADMIN";
    } else if (userType?.toUpperCase() === "SUPER_AGENT") {
      userTypeGet = "MASTER";
    } else if (userType?.toUpperCase() === "AGENT") {
      userTypeGet = "SUPER_AGENT";
    } else if (userType?.toUpperCase() === "CLIENT") {
      userTypeGet = "AGENT";
    }

    const { response } = await getUsersWithUserTypeAPI(userTypeGet);
    let response_ = response;
    if (response_) {
      setUserTypeList(response_);
    }
  };
  const getChildUserInfo = async () => {
    const { response } = await getChildUserInfoAPI(selectedParent?.value || location?.state?.userId);
    // console.log(response?.childInfo.balance);
    setClientData((prevState) => ({
      ...prevState,
      partnershipAndCommission: {
        ...prevState.partnershipAndCommission,
        casinoCommission: response?.childInfo?.casinoCommission,
        sessionCommission: response?.childInfo?.sessionCommission,
        matchCommission: response?.childInfo?.matchCommission,
        myCasinoPartnership: response?.childInfo?.myCasinoPartnership,
        myPartnership: response?.childInfo?.myPartnership,
        balance: response?.childInfo?.balance,
      },
    }));
  };

  useEffect(() => {
    getUsersWithUserType();
    if (selectedParent?.value && selectedParent?.value !== userData?.uid && location?.state) {
      getChildUserInfo();
    } else {
      getUserInfo();
    }
  }, [selectedParent?.value || location?.state]);

  const getUserInfo = async () => {
    const { response } = await getUserDataAPI();
    setIsAdmin(false);
    setClientData(response);
  };

  const handleSubmit = async () => {
    let filteredPayload = {
      ...payload,
    };
    if (!payload.fullName) {
      toast.error(`Please fill in the Name field.`);
      return;
    }

    if (!payload.balance) {
      filteredPayload.balance = 0;
    }

    if (!payload.myPartnership && !userType?.toUpperCase() == "CLIENT") {
      toast.error(`Please fill in the ${userType} Share field.`);
      return;
    }
    if (
      !payload.myCasinoPartnership &&
      !userType?.toUpperCase() == "CLIENT" ||
      !userType.toUpperCase() == "CONTROLLER"
    ) {
      toast.error(`Please fill in the ${userType} Casino Share field.`);
      return;
    }
    // if (!payload.commissionOn || !userType.toUpperCase() == "CONTROLLER") {
    //   toast.error(`Please fill in the Commission Type field.`);
    //   return;
    // }
    if (
      userType.toUpperCase() == "ADMIN" ||
      userType.toUpperCase() == "CONTROLLER"
    ) {
      if (
        userType.toUpperCase() == "CONTROLLER" &&
        filteredPayload?.username < 3
      ) {
        toast.error("Username must be at least 3 characters long");
        return;
      }
      if (filteredPayload.balance > userData?.balance) {
        toast.error("Limit can not be greater than your partnership");
        return;
      }
    } else {
      if (
        filteredPayload.balance >
        clientData?.partnershipAndCommission?.balance
      ) {
        toast.error("Limit can not be greater than your partnership");
        return;
      }
    }
    if (
      filteredPayload.matchCommission >
      clientData?.partnershipAndCommission?.matchCommission
    ) {
      setPayload({
        ...payload,
        matchCommission: "",
      });
      toast.error(
        "Match Commission can not be greater than your partnership"
      );
      return;
    }

    if (
      filteredPayload.sessionCommission >
      clientData?.partnershipAndCommission?.sessionCommission
    ) {
      setPayload({
        ...payload,
        sessionCommission: "",
      });
      toast.error(
        "Session Commission can not be greater than your partnership"
      );
      return;
    }

    if (
      filteredPayload.casinoCommission >
      clientData?.partnershipAndCommission?.casinoCommission
    ) {
      setPayload({
        ...payload,
        casinoCommission: "",
      });
      toast.error(
        "Casino Commission can not be greater than your partnership"
      );
      return;
    }
    if (
      filteredPayload.myCasinoPartnership >
      clientData?.partnershipAndCommission?.myCasinoPartnership
    ) {
      setPayload({
        ...payload,
        myCasinoPartnership: "",
      });
      toast.error("Casino Share can not be greater than your partnership");
      return;
    }
    delete filteredPayload["confirmPassword"];
    var pass = generatePassword();
    filteredPayload.password = Encrypt(payload.password || pass);
    setPayload({
      ...payload,
      password: pass || payload.password,
    });
    filteredPayload.userType = userType.toUpperCase();
    filteredPayload.commissionOn = 'false';
    filteredPayload.parentUserId = selectedParent?.value;
    // filteredPayload.parentUserId = clientData?.uid;
    filteredPayload.parentCasinoPartnership =
      clientData?.partnershipAndCommission?.myCasinoPartnership;
    if (userType?.toUpperCase() == "CLIENT") {
      filteredPayload.parentPartnership = payload.myShare;
    }
    if (filteredPayload?.parentUserId == userData?.uid) {
      delete filteredPayload["parentUserId"];
    }
    try {
      const { response, code, error, status } = await addNewClientAPI(
        filteredPayload
      );
      if (code === 200) {
        toast.success(response?.status || "User Added Successfully");
        setTimeout(() => {
          window.location.href = `/${userType}`;
        }, 1500);
      } else if (code !== 200 && status) {
        toast.error(
          status || "Something went wrong Please check all you field"
        );
      } else {
        toast.error(
          error.description ||
          "Something went wrong Please check all you field"
        );
        setPayload({
          ...payload,
          password: "",
          confirmPassword: "",
        });
      }
    } catch (err) {
      setPayload({});
      toast.error(
        err.message || "Something went wrong Please check all you field"
      );
    }
  };

  const handleCommissionChange = (e) => {
    const commissionOn = e.target.value == "true";

    setPayload({
      ...payload,
      commissionOn,
    });
    const defaultValues = commissionOn
      ? {
        matchCommission:
          clientData?.partnershipAndCommission.matchCommission || 0,
        sessionCommission:
          clientData?.partnershipAndCommission.sessionCommission || 0,
        casinoCommission:
          clientData?.partnershipAndCommission.casinoCommission || 0,
      }
      : {
        matchCommission: 0,
        sessionCommission: 0,
        casinoCommission: 0,
      };
    setPayload((prevState) => ({
      ...prevState,
      ...defaultValues,
      commissionOn: "false",
    }));
  };

  useEffect(() => {
    setClientData({
      partnershipAndCommission: {
        matchCommission: 0,
        sessionCommission: 0,
        casinoCommission: 0,
      },
    });
  }, []); // Runs only once on component mount

  const generatePassword = () => {
    const passwordLength = 6;
    let newPassword = '';
    for (let i = 0; i < passwordLength; i++) {
      newPassword += Math.floor(Math.random() * 10); // Generate a random number between 0 and 9
    }
    setPayload({
      ...payload,
      password: newPassword
    });
    return newPassword
  };

  useEffect(() => {
   generatePassword()
  },[])

  const shareDetails = (client) => {
    let url = `https://api.whatsapp.com/send?text=ID:${client?.username
      }%0APW:${client?.password}%0ALINK:${userType?.toLowerCase() == "client"
        ? `${import.meta.env.VITE_APP_NAME}.com`
        : `operator.${import.meta.env.VITE_APP_NAME}.com`
      }`;
    window.open(url, "_blank");
  };

  return (
    <div className="content-wrapper" style={{ minHeight: 1252 }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Create {userType}</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/super">Super</a>
                </li>
                <li className="breadcrumb-item active">New {userType}</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <form action="/master/store" method="POST">
          <input
            type="hidden"
            name="_csrf"
            defaultValue="ba9d3d2b-b2c1-4143-bd84-a7f988415a48"
          />
          <div className="row">
            <div className="col-md-6">
              <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">General</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      data-toggle="tooltip"
                      title="Collapse"
                    >
                      <i className="fas fa-minus" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-group">
                    <label htmlFor="code">UserName</label>
                    <input
                      type="text"
                      id="code"
                      placeholder=""
                      className="form-control"
                      name="code"
                      value={payload?.username}
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          username: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Name"
                      value={payload?.fullName}
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          fullName: e.target.value,
                        })
                      }
                      min={2}
                      name="name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Reference</label>
                    <input
                      type="text"
                      id="reference"
                      className="form-control"
                      placeholder="Reference"
                      name="reference"
                      value={payload?.reference}
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          reference: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="input-group ">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Password"
                        min={6}
                        id="password"
                        value={payload.password}
                        onChange={(e) =>
                          setPayload({
                            ...payload,
                            password: e.target.value,
                          })
                        }
                        name="password"
                        defaultValue=""
                      />
                      <span className="input-group-append">
                        <button type="button" className="btn btn-info btn-flat"
                          onClick={generatePassword}
                        >
                          Generate Password
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="mobile">Contact No</label>
                    <input
                      type="number"
                      className="form-control"
                      id="mobile"
                      placeholder="Mobile No"
                      name="mobile"
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          mobile: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <a onClick={() => {
                        window.location.href = `/${userType}`;
                      }} className="btn btn-secondary">
                        Cancel
                      </a>
                      <button type="button"
                        onClick={handleSubmit}
                        className="btn btn-success float-right">
                        Create New {userType}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 " style={{ display: 'none' }}>
              <div className="card card-secondary">
                <div className="card-header">
                  <h3 className="card-title">Share and Commission</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      data-toggle="tooltip"
                      title="Collapse"
                    >
                      <i className="fas fa-minus" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    {/* <div className="form-group col-md-6">
                      <label
                        htmlFor="share"
                        style={{ textTransform: "capitalize" }}
                      >
                        {userType} Limit
                      </label>
                      <input

                        formcontrolname="free_chip"
                        type="text"
                        id="name"
                        name="name"
                        value={payload?.balance}
                        onChange={(e) => {
                          if (
                            (userData?.userType === "SUPER_ADMIN" &&
                              userType.toUpperCase() === "ADMIN") ||
                              (userData?.userType === "ADMIN" &&
                                userType.toUpperCase() === "SUB_ADMIN") ||
                              (userData?.userType === "SUB_ADMIN" &&
                                userType.toUpperCase() === "MASTER") ||
                              (userData?.userType === "MASTER" &&
                                userType.toUpperCase() === "SUPER_AGENT") ||
                              (userData?.userType === "SUPER_AGENT" &&
                                userType.toUpperCase() === "AGENT") ||
                              (userData?.userType === "AGENT" &&
                                userType.toUpperCase() === "CLIENT")
                              ? userData?.balance - e.target.value < 0
                              : clientData?.partnershipAndCommission?.balance -
                              e.target.value <
                              0
                          ) {
                            toast.error(
                              "Limit can not be greater than your partnership"
                            );
                            return;
                          }
                          setPayload({
                            ...payload,
                            balance: e.target.value,
                          });
                        }}
                        className="form-control ng-untouched ng-pristine ng-valid"
                      />
                    </div> */}
                    {/* <div className="form-group col-md-6">
                      <label htmlFor="mshare">My Limit</label>
                      <input
                        readOnly=""
                        type="text"
                        disabled
                        placeholder={0}
                        formcontrolname="remainingLimit"
                        id="name"
                        name="name"
                        value={
                          (
                            (
                              (userData?.userType === "SUPER_ADMIN" &&
                                userType.toUpperCase() === "ADMIN") ||
                              (userData?.userType === "ADMIN" &&
                                userType.toUpperCase() === "SUB_ADMIN") ||
                              (userData?.userType === "SUB_ADMIN" &&
                                userType.toUpperCase() === "MASTER") ||
                              (userData?.userType === "MASTER" &&
                                userType.toUpperCase() === "SUPER_AGENT") ||
                              (userData?.userType === "SUPER_AGENT" &&
                                userType.toUpperCase() === "AGENT") ||
                              (userData?.userType === "AGENT" &&
                                userType.toUpperCase() === "CLIENT")
                            )
                              ? userData?.balance - Number(payload?.balance ?? 0)
                              : clientData?.partnershipAndCommission?.balance -
                              Number(payload?.balance ?? 0)
                          ).toFixed(2)
                        }
                        // value={
                        //   (userData?.userType === "SUPER_ADMIN" &&
                        //     userType.toUpperCase() === "ADMIN") ||
                        //     (userData?.userType === "ADMIN" &&
                        //       userType.toUpperCase() === "SUB_ADMIN") ||
                        //     (userData?.userType === "SUB_ADMIN" &&
                        //       userType.toUpperCase() === "MASTER") ||
                        //     (userData?.userType === "MASTER" &&
                        //       userType.toUpperCase() === "SUPER_AGENT") ||
                        //     (userData?.userType === "SUPER_AGENT" &&
                        //       userType.toUpperCase() === "AGENT") ||
                        //     (userData?.userType === "AGENT" &&
                        //       userType.toUpperCase() === "CLIENT")
                        //     ? userData?.balance -
                        //     (payload?.balance ? payload?.balance?.toFixed(2) : 0)
                        //     : clientData?.partnershipAndCommission?.balance -
                        //     (payload?.balance?.toFixed(2) ? payload?.balance?.toFixed(2) : 0)
                        // }
                        className="form-control ng-untouched ng-pristine ng-valid"
                      />
                    </div> */}
                  </div>
                  {userType?.toLowerCase() != "client" && (
                    <>
                      <div className="form-group row">
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="share"
                            style={{ textTransform: "capitalize" }}
                          >
                            {userType} Share
                          </label>
                          <input
                            type="number"
                            max={
                              clientData?.partnershipAndCommission?.myPartnership
                            }
                            defaultValue={0}
                            min={0.0}
                            value={payload?.myPartnership}
                            onChange={(e) =>
                              setPayload({
                                ...payload,
                                myPartnership: e.target.value,
                              })
                            }
                            readOnly=""
                            className="form-control"
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="mshare">My Share</label>
                          <input
                            type="number"
                            placeholder="Share"
                            className="form-control"
                            id="mshare"
                            readOnly
                            value={
                              clientData?.partnershipAndCommission
                                ?.myPartnership -
                              (payload?.myPartnership
                                ? payload?.myPartnership
                                : 0)
                            }
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="form-group col-md-6">
                          <label
                            htmlFor="share"
                            style={{ textTransform: "capitalize" }}
                          >
                            {userType} Casino Share
                          </label>
                          <input
                            type="number"
                            max={
                              clientData?.partnershipAndCommission
                                ?.myCasinoPartnership
                            }
                            min={0.0}
                            // defaultValue={0}
                            id="casino_commission"
                            required=""
                            defaultValue={payload?.myCasinoPartnership || 0}
                            name="casinoCommission"
                            onChange={(e) =>
                              setPayload({
                                ...payload,
                                myCasinoPartnership: e.target.value,
                              })
                            }
                            className="form-control disabled ng-untouched ng-pristine ng-invalid"
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="cmshare">My Casino Share</label>
                          <input
                            type="text"
                            placeholder="Share"
                            className="form-control"
                            id="cmshare"
                            readOnly
                            defaultValue={
                              clientData?.partnershipAndCommission
                                ?.myCasinoPartnership
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label htmlFor="commissionOn">Commission Type</label>
                    <select id="commissionOn" className="form-control"
                      onChange={(e) => {
                        handleCommissionChange(e);
                        setIsCommission(e.target.value);
                      }}
                      value={
                        payload?.commissionOn
                          ? payload?.commissionOn
                          : clientData?.partnershipAndCommission
                            ?.sessionCommission
                            ? userType?.toLowerCase() === "client" ? "false" : "true"
                            : "false"
                      }
                    >
                      <option>Please Select..</option>
                      <option value={false}>No Comm</option>
                      <option value={true}>Bet by Bet</option>
                    </select>
                  </div>
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="match_commission">Match Commision</label>
                      <input
                        type="number"
                        className="form-control"
                        step="0.01"
                        id="match_commission"
                        required
                        name="matchcommission"
                        min={0}
                        max={clientData?.partnershipAndCommission?.matchCommission ?? 0}
                        value={payload?.matchCommission ?? 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/^0+(?=\d)/, ""); // prevent 03
                          let numValue = Number(value);
                          const max =
                            Number(
                              clientData?.partnershipAndCommission?.matchCommission
                            ) || 0;

                          if (numValue < 0 || numValue > max) return;

                          setPayload({
                            ...payload,
                            matchCommission: value,
                          });
                        }}
                      />

                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mc">My Match Commission</label>
                      <input
                        id="mc"
                        type="text"
                        min={0}
                        max={3}
                        value={clientData?.partnershipAndCommission
                          ?.matchCommission}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="session_commission">Session Commission</label>
                      <input
                        type="number"
                        className="form-control"
                        step="0.01"
                        id="session_commission"
                        required
                        name="sessioncommission"
                        min={0}
                        max={clientData?.partnershipAndCommission?.sessionCommission ?? 0}
                        value={payload?.sessionCommission ?? 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/^0+(?=\d)/, ""); // prevent 03
                          let numValue = Number(value);
                          const max =
                            Number(
                              clientData?.partnershipAndCommission?.sessionCommission
                            ) || 0;

                          if (numValue < 0 || numValue > max) return;

                          setPayload({
                            ...payload,
                            sessionCommission: value,
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mc">My Session Commission</label>
                      <input
                        type="number"
                        value={clientData?.partnershipAndCommission
                          ?.sessionCommission}
                        id="sc"
                        className="form-control"
                        placeholder="Session Commission"
                        readOnly
                      />
                    </div>
                  </div>
                  {/* {userType?.toLowerCase() != "client" && ( */}
                  <div className="form-group row">
                    <div className="form-group col-md-6">
                      <label htmlFor="casino_commission">Casino Commission</label>
                      <input
                        type="number"
                        className="form-control"
                        id="casino_commission"
                        required
                        name="casinoCommission"
                        min={0}
                        max={clientData?.partnershipAndCommission?.casinoCommission ?? 0}
                        value={payload?.casinoCommission ?? 0}
                        onChange={(e) => {
                          let value = e.target.value.replace(/^0+(?=\d)/, ""); // prevent 03
                          let numValue = Number(value);
                          const max =
                            Number(
                              clientData?.partnershipAndCommission?.casinoCommission
                            ) || 0;

                          if (numValue < 0 || numValue > max) return;

                          setPayload({
                            ...payload,
                            casinoCommission: value,
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="cc">My Casino Commission</label>
                      <input
                        type="number"
                        value={clientData?.partnershipAndCommission
                          ?.casinoCommission}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>

        </form>
        <br />
      </section>
    </div>

  );
}
